import React from 'react';
import { Section, AccordionItem, Button, Countdown } from './ui';
import { ShieldCheck, Star, CheckCircle2 } from 'lucide-react';
const CHECKOUT_URL = 'https://sistema-iphone-ads.myshopify.com/cart/add?id=46176935641285&quantity=1&return_to=/cart';
export const Testimonials = () => {
  const testimonials = [{
    text: 'Lo que más me sirvió fue entender que no necesitaba arrancar comprando varios equipos. Primero tenía que entender cómo vender por pedido y cómo moverme mejor.',
    author: 'Alumno del curso'
  }, {
    text: 'Antes pensaba que para empezar necesitaba stock. El curso me ordenó la cabeza y me mostró una forma más lógica de entrar al negocio.',
    author: 'Alumno del curso'
  }, {
    text: 'Me ayudó a ver qué errores evitar antes de poner plata en un iPhone. Eso solo ya me pareció clave.',
    author: 'Alumno del curso'
  }, {
    text: 'La parte de marketing me sirvió para entender cómo comunicar mejor y no depender solo de subir fotos a Instagram.',
    author: 'Alumno del curso'
  }, {
    text: 'Me gustó que no sea solo anuncios. También explica negocio, proveedores, venta por pedido y cómo pensar el rubro desde cero.',
    author: 'Alumno del curso'
  }, {
    text: 'Es simple, directo y va al punto. Te muestra qué mirar antes de comprar, cómo evitar errores y cómo empezar con más claridad.',
    author: 'Alumno del curso'
  }];
  const duplicatedTestimonials = [...testimonials, ...testimonials];
  return <Section className="bg-white/[0.02] border-y border-white/[0.05] backdrop-blur-sm overflow-hidden py-12" data-id="element-114">
      <div className="text-center mb-10 max-w-3xl mx-auto px-6" data-id="element-115">
        <h2 className="text-2xl md:text-3xl font-bold text-white mb-3" data-id="element-116">
          Lo que más valoran quienes empiezan
        </h2>
      </div>

      <div className="relative w-full flex overflow-hidden group" data-id="element-117">
        <div className="absolute top-0 left-0 w-12 md:w-32 h-full bg-gradient-to-r from-zinc-950 to-transparent z-10 pointer-events-none" data-id="element-118"></div>
        <div className="absolute top-0 right-0 w-12 md:w-32 h-full bg-gradient-to-l from-zinc-950 to-transparent z-10 pointer-events-none" data-id="element-119"></div>

        <div className="flex w-max animate-marquee hover:[animation-play-state:paused] gap-6 px-3" data-id="element-120">
          {duplicatedTestimonials.map((t, i) => <div key={i} className="w-[280px] md:w-[340px] bg-zinc-900/60 backdrop-blur-sm border border-white/[0.05] rounded-2xl p-5 flex flex-col shadow-lg hover:border-blue-500/30 transition-colors flex-shrink-0" data-id="element-121">
              <div className="flex space-x-1 mb-3" data-id="element-122">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-emerald-500 text-emerald-500" data-id="element-123" />)}
              </div>
              <p className="text-zinc-300 flex-1 mb-4 text-sm leading-relaxed" data-id="element-124">
                "{t.text}"
              </p>
              <div className="flex items-center space-x-3" data-id="element-125">
                <div className="w-8 h-8 rounded-full bg-zinc-800 border border-white/[0.05] flex items-center justify-center" data-id="element-126">
                  <CheckCircle2 className="w-4 h-4 text-emerald-500" data-id="element-127" />
                </div>
                <span className="text-xs font-semibold text-zinc-400" data-id="element-128">
                  {t.author}
                </span>
              </div>
            </div>)}
        </div>
      </div>
    </Section>;
};
export const Guarantee = () => {
  return <Section className="bg-white/[0.02] border-y border-white/[0.05] backdrop-blur-sm py-12" data-id="element-129">
      <div className="max-w-2xl mx-auto text-center" data-id="element-130">
        <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-blue-500/10 mb-4" data-id="element-131">
          <ShieldCheck className="w-6 h-6 text-blue-500" data-id="element-132" />
        </div>
        <h2 className="text-2xl md:text-3xl font-bold text-white mb-4" data-id="element-133">
          Comprá con tranquilidad
        </h2>
        <p className="text-base text-zinc-300 mb-2" data-id="element-134">
          Tenés <span className="font-bold text-white" data-id="element-135">7 días de garantía</span>{' '}
          para revisar el contenido.
        </p>
        <p className="text-xs text-zinc-500" data-id="element-136">
          La garantía aplica si no se consumió una parte significativa del curso
          ni se descargaron materiales internos.
        </p>
      </div>
    </Section>;
};
export const HowItWorks = () => {
  const steps = ['Comprás', 'Recibís el acceso por mail', 'Entrás al contenido', 'Podés verlo a tu ritmo'];
  return <Section className="py-12" data-id="element-137">
      <div className="max-w-3xl mx-auto" data-id="element-138">
        <h2 className="text-2xl md:text-3xl font-bold text-white mb-8 text-center" data-id="element-139">
          ¿Cómo funciona después de comprar?
        </h2>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-140">
          {steps.map((step, i) => <div key={i} className="flex flex-col items-center text-center p-4 bg-zinc-900/50 backdrop-blur-sm rounded-xl border border-white/[0.05]" data-id="element-141">
              <div className="flex items-center justify-center w-8 h-8 rounded-full bg-emerald-500/10 mb-3" data-id="element-142">
                <span className="text-emerald-500 font-bold text-sm" data-id="element-143">
                  {i + 1}
                </span>
              </div>
              <p className="text-zinc-300 font-medium text-sm" data-id="element-144">{step}</p>
            </div>)}
        </div>
      </div>
    </Section>;
};
export const FAQ = () => {
  const faqs = [{
    q: '¿El curso es grabado?',
    a: 'Sí, el curso es 100% grabado y digital. Podés acceder y avanzar a tu propio ritmo.'
  }, {
    q: '¿Necesito tener stock?',
    a: 'No. Una parte importante del curso explica cómo empezar sin stock propio y cómo vender por pedido.'
  }, {
    q: '¿Incluye acompañamiento?',
    a: 'No, el acceso de $19.000 corresponde al curso digital grabado. No incluye acompañamiento grupal ni personalizado.'
  }, {
    q: '¿Cómo recibo el acceso?',
    a: 'Después de realizar el pago, recibís las instrucciones de acceso automáticamente por mail.'
  }];
  return <Section className="py-12" data-id="element-145">
      <div className="max-w-2xl mx-auto" data-id="element-146">
        <h2 className="text-2xl md:text-3xl font-bold text-white mb-8 text-center" data-id="element-147">
          Preguntas Frecuentes
        </h2>
        <div className="bg-zinc-900/50 backdrop-blur-sm border border-white/[0.05] rounded-2xl p-4 shadow-md" data-id="element-148">
          {faqs.map((faq, i) => <AccordionItem key={i} question={faq.q} answer={faq.a} data-id="element-149" />)}
        </div>
      </div>
    </Section>;
};
export const FinalCTA = () => {
  return <Section className="pb-24" data-id="element-150">
      <div className="max-w-3xl mx-auto rounded-3xl p-8 md:p-12 text-center relative overflow-hidden border border-white/[0.1] shadow-xl bg-zinc-900" data-id="element-151">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-blue-600/20 via-transparent to-transparent pointer-events-none" data-id="element-152"></div>

        <div className="relative z-10" data-id="element-153">
          <h2 className="text-3xl md:text-4xl font-extrabold text-white mb-8" data-id="element-154">
            Últimos minutos para acceder con precio especial
          </h2>

          <div className="space-y-8" data-id="element-155">
            <div className="flex items-center justify-center space-x-4" data-id="element-156">
              <span className="text-3xl md:text-4xl font-bold text-white" data-id="element-157">
                Hoy: $19.000
              </span>
              <span className="text-lg text-zinc-500 line-through" data-id="element-158">
                $40.000
              </span>
            </div>

            <div className="max-w-sm mx-auto" data-id="element-159">
              <Countdown data-id="element-160" />
            </div>

            <div className="flex flex-col items-center space-y-4" data-id="element-161">
              <Button href={CHECKOUT_URL} className="w-full md:w-auto py-5 text-xl px-12 shadow-[0_0_30px_rgba(16,185,129,0.2)]" data-id="element-162">
                Acceder ahora por $19.000
              </Button>

              <p className="text-sm text-zinc-400" data-id="element-163">
                Después de esta cuenta regresiva, el acceso vuelve a $40.000.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Section>;
};